export enum TaxPixType {
  full = '0,9%',
  tef = '0,8%',
}
